//libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

//components
import SortView from 'shared/components/Filter/components/SortView';

//styles
import { Wrapper } from './styles';

//selectors
import { getAppliedFilters } from 'shared/store/listingV2/selectors';

//hooks
import { useFilters } from 'shared/store/listingV2/hooks';

//helpers
import { getSelectedSort } from 'shared/store/listingV2/helpers';

//constants
import { API_KEYS } from 'shared/store/listingV2/constants';

const SortFilter = () => {
  const { updateAppliedFilter } = useFilters();
  const appliedFilters = useSelector(getAppliedFilters);
  const selectedSort = getSelectedSort(appliedFilters);

  const onApplyClick = (value: string) => {
    let appliedFiltersValues = { ...appliedFilters };
    appliedFiltersValues[API_KEYS.SORT_FILTER] = value;
    updateAppliedFilter(appliedFiltersValues);
  };

  return (
    <Wrapper>
      <SortView onApplyClick={onApplyClick} selectedSort={selectedSort} />
    </Wrapper>
  );
};
export default memo(SortFilter);
